import React, { useState } from "react";
import AboutBG from "./img/about-banner-bg.jpg";
import "./style.scss";
import HTMLReactParser from "html-react-parser";

export default function StartupIndia(props) {
  const Banner = props.data[0];
  const BannerImage = Banner.BannerImage;
  const BannerTitle = Banner.BannerTitle;
  const BannerSubtitle = Banner.BannerSubtitle;
  return Banner ? (
    <div className="start-up-india">
      <section
        style={{
          background: AboutBG,
          backgroundPosition: "center",
          backgroundSize: "cover",
          marginTop: "90px",
        }}
        id="banner"
      >
        <div className="w-100 pt-50 pb-0 position-relative">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInLeft">
                <div
                  className="mckp-img text-center tilt w-100"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                >
                  <img
                    className="img-fluid"
                    src={BannerImage}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInRight">
                <div
                  className="content homepageFirstHeader homepageFirstDescription"
                  style={{
                    fontSize: "20px",
                    textAlign: "justify",
                    lineHeight: "25px",
                  }}
                >
                  {HTMLReactParser(BannerTitle)}
                  <br />
                  {HTMLReactParser(BannerSubtitle)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  ) : null;
}
